import React, { useState, useEffect, useCallback, useRef, FC, SyntheticEvent, ChangeEvent } from 'react'
import { isServer } from 'out-game/constants'

import { InputProps } from './Input.types'
import { ReactComponent as SendIcon } from '../../assets/icons/send-icon.svg'
import { ReactComponent as SmileyIcon } from '../../assets/icons/smiley-icon.svg'
import './Input.scss'

let Picker: any | null = null
if (!isServer) {
  Picker = require('emoji-picker-react').default
}

const Input: FC<InputProps> = ({
     onClickSend,
     onJoinChat,
     isUserConnected,
     disabled = false
   }) => {
  const [isPickerVisible, setIsPickerVisible] = useState(false)
  const [value, setNewValue] = useState('')
  const inputRef = useRef<HTMLTextAreaElement>(null)

  const insertAtCaret = (text: string) => {
    const element = inputRef.current
    if (!element) {
      return
    }
    const startPos = element.selectionStart

    if (startPos || startPos === 0) {
      const endPos = element.selectionEnd
      setNewValue(
        element.value.substring(0, startPos) +
        text +
        element.value.substring(endPos || 0, element.value.length),
      )
      element.focus()
    } else {
      setNewValue(`${value} ${text}`)
      element.focus()
    }
  }

  const onEmojiClick = (
    event: SyntheticEvent,
    emojiObject: { emoji: string },
  ) => {
    insertAtCaret(emojiObject.emoji)
  }

  const mouseListener = useCallback(
    (evt) => {
      if (!isPickerVisible) {
        return
      }

      if (
        evt.target &&
        evt.target.classList &&
        !evt.target.classList.contains('emoji-group') &&
        !evt.target.classList.contains('emoji-img') &&
        !evt.target.parentNode.classList.contains('emoji-categories') &&
        isPickerVisible
      ) {
        setIsPickerVisible(false)
      }
    },
    [setIsPickerVisible, isPickerVisible],
  )

  const keyboardListener = useCallback(
    (evt) => {
      if (evt.key === 'Escape') {
        setIsPickerVisible(false)
      }
      if (
        evt.key === 'Enter' &&
        !evt.shiftKey &&
        evt.target.classList.contains('input__text')
      ) {
        if (inputRef.current) {
          inputRef.current.style.height = 'auto'
        }
        onClickSend(value)
        setNewValue('')
      }
    },
    [setIsPickerVisible, value],
  )

  const onClickText = () => {
    if (!isUserConnected) {
      onJoinChat()
    }
  }

  useEffect(() => {
    if (!isServer) {
      document.addEventListener('click', mouseListener)
      document.addEventListener('keyup', keyboardListener)
      return () => {
        document.removeEventListener('click', mouseListener)
        document.removeEventListener('keyup', keyboardListener)
      }
    }
  }, [mouseListener, keyboardListener])

  function changeHandler(e: ChangeEvent<HTMLTextAreaElement>) {
    const { target } = e

    setNewValue(target.value)

    target.style.height = 'auto'
    target.style.height = target.scrollHeight + 'px'
  }

  return (
    <div className='input js-general-chat'>
      <div>
        <textarea
          ref={inputRef}
          value={value}
          className='input__text'
          onClick={onClickText}
          onChange={changeHandler}
          disabled={disabled}
        />
      </div>
      <button
        className='input__button input__button_smile'
        onClick={() => {
          setIsPickerVisible(true)
        }}
        disabled={disabled}
      >
        <SmileyIcon />
      </button>
      {isPickerVisible && !!Picker && (
        <div className='input__emoji'>
          <Picker onEmojiClick={onEmojiClick} />
        </div>
      )}
      <button className='input__button input__button_send'>
        <SendIcon
          onClick={() => {
            onClickSend(value)
            setNewValue('')
          }}
        />
      </button>
    </div>
  )
}

export default Input
